import { defineStore } from 'pinia'

// §59 of the master spec — kept exact so later phases (SFU wiring, recording,
// NOW bridge) extend this shape instead of replacing it.
export type MeetingStatus = 'LOBBY' | 'CONNECTING' | 'CONNECTED' | 'RECONNECTING' | 'ENDING' | 'ENDED'
export type RecordingState =
  | 'IDLE'
  | 'REQUESTED'
  | 'STARTING'
  | 'RECORDING'
  | 'STOPPING'
  | 'PROCESSING'
  | 'READY'
  | 'FAILED'
export type ProgramMode = 'FULL_MEETING' | 'SPEAKER' | 'BRIEFING' | 'PRESENTATION_ONLY' | 'CAMERA_ONLY'
export interface BroadcastState {
  active: boolean
  mode: ProgramMode | null
}
export interface PresentationState {
  assetId: string
  presenterId: string
}

export interface MeetingState {
  meetingId: string
  roomCode: string
  status: MeetingStatus
  isHost: boolean
  recordingState: RecordingState
  recordingUrl: string | null
  broadcastState: BroadcastState
  presentation: PresentationState | null
}

function emptyMeeting(): MeetingState {
  return {
    meetingId: '',
    roomCode: '',
    status: 'LOBBY',
    isHost: false,
    recordingState: 'IDLE',
    recordingUrl: null,
    broadcastState: { active: false, mode: null },
    presentation: null
  }
}

export const useMeetingStore = defineStore('meeting', {
  state: () => ({ ...emptyMeeting() }),
  actions: {
    reset() {
      Object.assign(this, emptyMeeting())
    },
    setStatus(status: MeetingStatus) {
      this.status = status
    }
  }
})
